import { Right } from "@/type/core/offices/offices.types";
import BasicButton from "@components/core/buttons/BasicButton";
import { ROUTES } from "@routes/Routes";
import { requestDeleteTransaction } from "@state/transactions/TransactionEffects";
import UserIcon from "@static/core/icons/icon-user.svg?react";
import { TransactionDetail } from "@type/core/transaction/transaction.types";
import { toastError } from "@utils/helpers/toast-helper";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface TransactionDeleteButtonProps {
  transactionId?: string;
  transaction: TransactionDetail;
  setLoading: (loading: boolean) => void;
  officeRights?: Right[];
  signatureRight: Right;
  scellementRight: Right;
  label: string;
  className?: string;
}

const TransactionDeleteButton: FunctionComponent<
  TransactionDeleteButtonProps
> = ({
  transactionId,
  transaction,
  setLoading,
  officeRights,
  signatureRight,
  scellementRight,
  label,
  className = "",
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const signatureType = transaction && transaction.type === "signature";
  const scellementType = transaction && transaction.type === "scellement";

  const deleteTransaction = (): void => {
    if (transactionId) {
      setLoading(true);
      void requestDeleteTransaction({ id: transactionId, dto: {} })
        .then((result) => {
          if (result.ok) {
            navigate(ROUTES.extranet.home.generate());
          } else {
            toastError(t("Erreur lors de la suppression de la transaction"));
          }
        })
        .finally(() => setLoading(false));
    }
  };

  if (
    (signatureType && officeRights?.includes(signatureRight)) ||
    (scellementType && officeRights?.includes(scellementRight))
  ) {
    return (
      <BasicButton
        variant="transparent-tertiary"
        icon={<UserIcon />}
        text={label}
        onClick={() => deleteTransaction()}
        className={`py-11 px-30 font-extra-small ${className}`}
      />
    );
  } else return null;
};

export default TransactionDeleteButton;
